import './Heading.css';

const Heading = ({ text }) => (
  <div className="heading">
    <p>{text}</p>
  </div>
);

export default Heading;
